// Heartfelt JS: AJAX Cart & Interactivity

document.addEventListener('DOMContentLoaded', () => {
  initAjaxForms();
  initWishlistButtons();
});

// === CART DRAWER LOGIC ===

function openCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('CartDrawerOverlay');
  const content = document.getElementById('CartDrawerContent');
  
  if (drawer && overlay && content) {
    drawer.classList.remove('hidden');
    // small delay for transition
    setTimeout(() => {
      overlay.classList.remove('opacity-0');
      content.classList.remove('translate-x-full');
      drawer.classList.add('pointer-events-auto');
    }, 10);
    document.body.style.overflow = 'hidden'; // prevent background scrolling
  }
}

function closeCartDrawer() {
  const drawer = document.getElementById('CartDrawer');
  const overlay = document.getElementById('CartDrawerOverlay');
  const content = document.getElementById('CartDrawerContent');
  
  if (drawer && overlay && content) {
    overlay.classList.add('opacity-0');
    content.classList.add('translate-x-full');
    drawer.classList.remove('pointer-events-auto');
    
    setTimeout(() => {
      drawer.classList.add('hidden');
      document.body.style.overflow = ''; 
    }, 300); // match duration-300
  }
}

function refreshCartDrawer() {
  fetch(window.location.pathname + '?section_id=cart-drawer')
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      
      const newDrawer = html.querySelector('#shopify-section-cart-drawer');
      const currentDrawer = document.getElementById('shopify-section-cart-drawer');
      
      if (currentDrawer && newDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
        // Make sure it stays open if it was open
        openCartDrawer();
      }
      
      // Update header cart count
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          updateHeaderCartCount(cart.item_count);
        });
    });
}

function updateHeaderCartCount(count) {
  const cartIconContainer = document.querySelector('a[aria-label="shopping_cart"]');
  if (cartIconContainer) {
    let bubble = cartIconContainer.querySelector('.bg-error');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = "absolute top-1 right-1 bg-error text-on-error text-[10px] font-bold w-4 h-4 rounded-full flex items-center justify-center";
        cartIconContainer.appendChild(bubble);
      }
      bubble.textContent = count;
    } else {
      if (bubble) bubble.remove();
    }
  }
}

function updateCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(cart => {
    refreshCartDrawer();
  })
  .catch(error => console.error('Error updating cart:', error));
}

// Intercept Add to Cart forms
function initAjaxForms() {
  const addToCartForms = document.querySelectorAll('form[action^="/cart/add"]');
  
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const submitButton = form.querySelector('button[type="submit"]');
      const originalText = submitButton.innerHTML;
      submitButton.innerHTML = '<span class="material-symbols-outlined animate-spin">sync</span>';
      submitButton.disabled = true;

      const formData = new FormData(form);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(item => {
        refreshCartDrawer();
      })
      .catch((error) => {
        console.error('Error:', error);
        alert('Ürün sepete eklenirken bir hata oluştu.');
      })
      .finally(() => {
        submitButton.innerHTML = originalText;
        submitButton.disabled = false;
      });
    });
  });
}

// === WISHLIST LOGIC (LocalStorage) ===
function initWishlistButtons() {
  const wishlistButtons = document.querySelectorAll('button[aria-label="favorite"], button:has(span:contains("favorite"))');
  const storageKey = 'heartfelt_wishlist';
  let wishlist = JSON.parse(localStorage.getItem(storageKey) || '[]');
  
  // Custom pseudo-selector for text content since querySelector doesn't support :contains
  const allFavButtons = Array.from(document.querySelectorAll('button')).filter(b => b.querySelector('span.material-symbols-outlined') && b.querySelector('span.material-symbols-outlined').textContent.trim() === 'favorite');

  allFavButtons.forEach(btn => {
    // In this basic version, we just toggle the color.
    // For a real app, we'd need data-product-handle on the button to store exact products.
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const icon = btn.querySelector('span');
      if (icon.classList.contains('text-[#D65A73]') && icon.style.fontVariationSettings.includes('"FILL" 1')) {
        // Remove from wishlist
        icon.style.fontVariationSettings = '"FILL" 0';
        icon.classList.remove('text-[#D65A73]');
        icon.classList.add('text-on-surface-variant');
      } else {
        // Add to wishlist
        icon.style.fontVariationSettings = '"FILL" 1';
        icon.classList.remove('text-on-surface-variant');
        icon.classList.add('text-[#D65A73]');
        // Optional: Pop animation
        icon.classList.add('scale-125');
        setTimeout(() => icon.classList.remove('scale-125'), 200);
      }
    });
  });
}

// === MOBILE MENU LOGIC ===
function openMobileMenu() {
  const menu = document.getElementById('MobileMenu');
  const overlay = document.getElementById('MobileMenuOverlay');
  const content = document.getElementById('MobileMenuContent');
  
  if (menu && overlay && content) {
    menu.classList.remove('hidden');
    setTimeout(() => {
      overlay.classList.remove('opacity-0');
      content.classList.remove('-translate-x-full');
    }, 10);
    document.body.style.overflow = 'hidden';
  }
}

function closeMobileMenu() {
  const menu = document.getElementById('MobileMenu');
  const overlay = document.getElementById('MobileMenuOverlay');
  const content = document.getElementById('MobileMenuContent');
  
  if (menu && overlay && content) {
    overlay.classList.add('opacity-0');
    content.classList.add('-translate-x-full');
    
    setTimeout(() => {
      menu.classList.add('hidden');
      document.body.style.overflow = ''; 
    }, 300);
  }
}
